module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_IG_black-b2e5acafaf39baf4f9b0c96b77cd4830.svg";